export default __webpack_public_path__ + "static/media/Logo@3x.e09b2f4b.png";